var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "v-height-flag",
      staticStyle: { "min-height": "calc(100vh - 190px)" },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "mt20",
          attrs: { model: _vm.form, "label-width": "150px" },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 14 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "一号通AppId：", prop: "appId" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入APPID（从一号通平台申请）",
                          "show-password": "",
                          size: "small",
                        },
                        model: {
                          value: _vm.form.yihaotong_appid,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "yihaotong_appid", $$v)
                          },
                          expression: "form.yihaotong_appid",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-button",
                    { staticClass: "ml14 copy-data", attrs: { type: "text" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "https://api.crmeb.com",
                            target: "_blank",
                          },
                        },
                        [_vm._v("进入一号通平台 ")]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 14 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "一号通AppSecret：", prop: "appKey" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入APPKEY（从一号通平台申请）",
                          "show-password": "",
                          size: "small",
                        },
                        model: {
                          value: _vm.form.yihaotong_appsecret,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "yihaotong_appsecret", $$v)
                          },
                          expression: "form.yihaotong_appsecret",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: {
                    loading: _vm.loading,
                    size: "small",
                    type: "primary",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm()
                    },
                  },
                },
                [_vm._v("立即提交")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }